import axios from '../../api/http';
import router from "../../router/";
import {Cookie} from '../../util/storage'

const user = {
	state: {
		isLogin: false,
		users: {
			sit_account: '',
			sit_password: '',
			userId: localStorage.getItem('userId')
		}
	},

	getters: {
		/*getUser(state) {
			return state.users.userid;
		},
		logined() {
			let isLogin = Cookie.get('isLogin');

			return isLogin ? true : router.replace({
				path: '/login'
			});
		}*/
	},
	mutations: {
		set_userid(state, userid) {
			state.users.userId = userid;
			localStorage['userId'] = userid;
		},
		set_login(state, isLogin) {
			state.isLogin = isLogin;
			Cookie.set('isLogin', isLogin);
		},
		set_sit_account(state, sit_account) {
			state.users.sit_account = sit_account;
			localStorage['sit_account'] = sit_account;
		},
		set_sit_password(state, sit_password) {
			state.users.sit_password = sit_password;
			localStorage['sit_password'] = sit_password;
		},
	}
}
export default user


// WEBPACK FOOTER //
// ./src/store/modules/user.js